import SentEmailModal from "./SentEmailModal";

export default SentEmailModal;